import {Icon, Path, SVG} from '@wordpress/components';

const icon = (
	<SVG xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><Path d="M140 896q-24.75 0-42.375-17.625T80 836V316q0-24.75 17.625-42.375T140 256h680q24.75 0 42.375 17.625T880 316v520q0 24.75-17.625 42.375T820 896H140Zm0-60h110V316H140v520Zm170 0h340V316H310v520Zm400 0h110V316H710v520ZM310 316v520-520Z"/></SVG>
)
export default <Icon icon={ icon } />;
